import gsap, { SplitText } from "@lib/gsap";
import { onMount, onView, onTrack, onDestroy, onPageIn, onPageOut } from "./_";
import { isStaging } from "@/webflow/is-staging";

export default function (element, dataset) {
  let height = element.clientHeight;
  let lineCount = Math.floor(height / 32);

  for (let i = 0; i < lineCount; i++) {
    const line = document.createElement("div");
    line.classList.add("lined_bg_line");
    element.appendChild(line);
  }

  gsap.set(".lined_bg_line", {
    width: 0,
  });

  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: element,
      start: "top 80%",
      end: "top 30%",
      scrub: true,
      markers: isStaging,
    },
  });

  tl.to(".lined_bg_line", {
    width: "100%",
    stagger: 0.1,
  });

  onDestroy(() => {
    tl.kill();
  });
}
